import { AreaMasterThemeSizeConfig } from './types';

const medium: AreaMasterThemeSizeConfig = {
  areaMaster: {},
};

export default medium;
